import { Component, Input, OnInit } from "@angular/core"
import { ActivatedRoute } from "@angular/router"
import { PremiumColors } from "../../../models/collection/premiumColors.model"
import { PremiumSectionTopic } from "../../../models/collection/premiumSectionTopic.model"
import { ScreenBreakpoints } from "../../../services/window-size.service"
import {
    StickyNavbarContent,
    StickyNavbarTrigger,
} from "../../../shared-components/sticky-premium-navbar/sticky-navbar.model"
import Utils from "../../../utils/utils"
import { STATIC_IMAGES } from "../../../models/constants"

@Component({
    selector: "app-premium-collection-sticky-navbar",
    templateUrl: "./premium-collection-sticky-navbar.component.html",
    styleUrls: ["./premium-collection-sticky-navbar.component.scss"],
    providers: [
        { provide: StickyNavbarContent, useExisting: PremiumCollectionStickyNavbarComponent },
    ],
    standalone: false,
})
export class PremiumCollectionStickyNavbarComponent implements OnInit, StickyNavbarContent {
    public pbsLogo: string
    public selectedTopic: PremiumSectionTopic
    public screenBreakpoints = ScreenBreakpoints
    public height: number
    urlSegments: string[] = []

    @Input() public collectionSlug: string = ""
    @Input() public collectionTitle: string = ""
    @Input() public isStudent: boolean
    @Input() public colors: PremiumColors
    @Input() public topics: PremiumSectionTopic[]

    @Input()
    public logo: string

    constructor(
        public window: Window,
        private activatedRoute: ActivatedRoute
    ) {
        this.pbsLogo = STATIC_IMAGES.pbs_logo_white_with_text
    }

    public ngOnInit() {
        this.setURLSegments()
        const fragment: string = this.activatedRoute.snapshot.fragment
        this.selectedTopic = this.topics.find(
            (topic: PremiumSectionTopic): boolean => topic.titleForAutoscroll === fragment
        )
    }

    private setURLSegments() {
        this.urlSegments = ["/collection", this.collectionSlug, "home"]
        Utils.isPreviewMode() && this.urlSegments.push("preview")
    }

    public scrollToTopic(event: MouseEvent, topic: PremiumSectionTopic) {
        window.location.hash = topic.titleForAutoscroll
        const element: HTMLElement = document.getElementById(`section-${topic.titleForAutoscroll}`)
        if (element) {
            Utils.scrollIntoView(element, -this.height + 2)
        }
    }

    public update(trigger: StickyNavbarTrigger) {
        this.selectedTopic = this.topics.find(
            (topic: PremiumSectionTopic): boolean => topic.titleForAutoscroll === trigger.triggerId
        )
    }
}
